import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DropdownComponent,
      multi: true
    }
  ]
})
export class DropdownComponent implements ControlValueAccessor, OnInit, OnChanges {

  get value() {
    return this.selectedItem;
  }

  @ViewChild(MatSelect, {static: false}) selectCtrl: MatSelect;

  @Input() formControl: FormControl;
  @Input() items = [];
  @Input() label;
  @Input() placeholder = '';
  @Input() displayField = 'name';
  @Input() showNoneOption = false;
  @Input() noneOptionLabel = 'general.actions.none';
  @Input() isDisabled = false;
  @Input() showErrors = false;
  @Input() defaultSelection = null;
  @Input() reactive = false;

  @Output() selectionChange = new EventEmitter<any>();

  compareFn: ((f1: any, f2: any) => boolean) | null = this.compareItems;

  private onChangeCallback: (_: any) => {};
  private onTouchedCallback: (_: any) => {};

  private selectedItem = null;

  @HostBinding('class.reactive') get isReactive() {
    return this.reactive;
  }

  @HostBinding('class.disabled') get disabled() {
    return this.isDisabled;
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {

  }

  compareItems(item1: any, item2: any) {
    if (item1?.id && item2?.id) {
      return item1 && item2 ? item1.id === item2.id : item1 === item2;
    }
    return item1 && item2 ? item1.value === item2.value : item1 === item2;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultSelection) {
      if (this.defaultSelection && !this.selectedItem) {
        this.selectedItem = this.defaultSelection;
        this.onSelectionChange({value: this.defaultSelection});
      }
    }
  }

  writeValue(value) {
    this.selectedItem = value;
  }

  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef, 'disabled', isDisabled);
    this.isDisabled = isDisabled;
  }

  onSelectionChange(event) {
    const item = event.value;
    this.selectionChange.emit(item);
    this.doChanges(item);
  }

  private doChanges(item) {
    if (this.onChangeCallback) {
      this.onChangeCallback(item);
    }
    if (this.onTouchedCallback) {
      this.onTouchedCallback(item);
    }
  }
}
